import { MIN_PASSWORD_LENGTH, type PasswordCheckType } from './util_password';

interface PasswordRequirementsProps {
  checks: PasswordCheckType;
  /** Padding and radius, which differ between the dark panels and the wizard card. */
  className?: string;
}

/**
 * The live checklist under a new-password field. Each line turns gold as it is
 * satisfied, so the requirements read as progress rather than as a warning.
 *
 * Shared by every screen that sets a password, so the rule is stated the same
 * way wherever someone meets it.
 */
export function PasswordRequirements({ checks, className }: PasswordRequirementsProps) {
  return (
    <div className={`tw:bg-white/5 ${className ?? 'tw:rounded tw:p-3'}`}>
      <p className='tw:mb-2 tw:text-xs tw:text-white/50'>Password requirements:</p>
      <ul className='tw:space-y-1 tw:text-xs'>
        <li className={checks.longEnough ? 'tw:text-ed-gold' : 'tw:text-white/40'}>
          • At least {MIN_PASSWORD_LENGTH} characters
        </li>
        <li className={checks.matches ? 'tw:text-ed-gold' : 'tw:text-white/40'}>• Passwords must match</li>
      </ul>
    </div>
  );
}
